<template>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('Users')}}</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-btn style="float:right;color:white;margin-bottom: 20px" variant="light" @click="getAvailableLicenses" v-b-modal.modal-create-user>{{$t('Create User')}}</b-btn>
            </b-col>

          </b-row>
          <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 100px;">
            <b-spinner
              variant="secondary"
            ></b-spinner>
          </div>
          <!-- Main table element -->
          <b-table
            show-empty
            hover
            small
            responsive
            :items="$store.state.users"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(firstName)="row">
              <b-link class="nav-link no-padding" :to="'/users/'+row.item.id"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>
            </template>

            <template v-slot:cell(groups)="row">
                {{row.item.groups ? row.item.groups.length : 0 }}
            </template>

            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="outline-dark" size="sm" @click="resetPasswordModal(row.item.id)">
                {{$t('Reset Password')}}
              </b-button>
              <b-button variant="outline-danger" size="sm" @click="removeUser(row.item)">
                {{$t('Remove')}}
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="$store.state.users.length"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>
        </b-container>
      </div>
      <b-modal
        id="modal-create-user"
        ref="modal"
        :title="$t('Create User')"
        @show="resetUserModal"
        @hidden="resetUserModal"
        @ok="createUser"
        okVariant="light"
        ok-title-html="<span style='color:white;'>Submit</span>"
        header-bg-variant="light"
        header-text-variant="white"
      >

        <form ref="form">
          <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
            <b-spinner
              variant="secondary"
            ></b-spinner>
          </div>
          <b-form-group style="width: 50%;float:left;" id="input-group-2" label="First Name:" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="newUser.firstName"
              :state="$v.newUser.firstName.$dirty ? !$v.newUser.firstName.$error : null"
              required
              :placeholder="$t('First Name')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-1-live-feedback">
              {{$t('This is a required field')}}.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group style="width: 50%;float:left;padding-left: 5px" id="input-group-6" label="Last Name:" label-for="input-22">
            <b-form-input
              id="input-22"
              v-model="newUser.lastName"
              :state="$v.newUser.lastName.$dirty ? !$v.newUser.lastName.$error : null"
              required
              :placeholder="$t('Last Name')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback">
              {{$t('This is a required field')}}.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            :label="$t('Username/Email')"
            label-for="input-12"
            :description="$t('The email address must be unique for every user')"
          >
            <b-form-input
              id="input-12"
              v-model="newUser.email"
              type="email"
              autocomplete="off"
              required
              :placeholder="$t('Username/Email')"
              :state="$v.newUser.email.$dirty ? !$v.newUser.email.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-3-live-feedback">
              {{$t('Email/Username is required')}}.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            label="Password:"
            label-for="input-1"
            :description="$t('Select a password for the User')"
          >
            <b-form-input
              id="input-1"
              v-model="newUser.password"
              type="password"
              required
              autocomplete="off"
              :placeholder="$t('Enter Password')"
              :state="$v.newUser.password.$dirty ? !$v.newUser.password.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-4-live-feedback">
              {{$t('Email address is required and must be properly formatted')}}.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="input-group-99" :label="$t('Assign License')" label-for="input-99">
            <b-form-select
              id="input-99"
              size="sm"
              v-model="newUser.license"
              :options="availableLicenses"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group id="input-group-4" :label="$t('Status')" label-for="input-4">
            <b-form-select
              id="input-4"
              size="sm"
              v-model="newUser.status"
              :options="statuses"
              required
            ></b-form-select>
          </b-form-group>
        </form>
      </b-modal>
      <b-modal
        id="modal-reset-password"
        ref="modal"
        :title="$t('Reset Password')"
        @show="resetPasswordModalVars"
        @hidden="resetPasswordModalVars"
        @ok="resetPassword"
        okVariant="light"
        ok-title-html="<span style='color:white;'>Reset</span>"
        header-bg-variant="light"
        header-text-variant="white"
      >
        <form ref="form">
          <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
            <b-spinner
              variant="secondary"
            ></b-spinner>
          </div>
          <b-form-group
            label="New Password"
            label-for="name-input"
          >
            <b-form-input
              type="password"
              id="group-name"
              v-model="resetPasswordData.password"
              :state="$v.resetPasswordData.password.$dirty ? !$v.resetPasswordData.password.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              <span v-if="!$v.resetPasswordData.password.required"> {{$t('Password is a required field')}} </span>
              <span v-if="!$v.resetPasswordData.password.minLength"> {{$t('Password must have at least')}} {{ $v.resetPasswordData.password.$params.minLength.min }} {{$t('letters')}}.</span>
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$t('Repeat Password')"
            label-for="name-input"
          >
            <b-form-input
              type="password"
              id="group-name"
              v-model="resetPasswordData.repeatPassword"
              :state="$v.resetPasswordData.repeatPassword.$dirty ? !$v.resetPasswordData.repeatPassword.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              <span v-if="!$v.resetPasswordData.repeatPassword.sameAsPassword">{{$t('Passwords must be identical')}}.</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </form>
      </b-modal>
    </div>

</template>

<script>
import moment from 'moment'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      availableLicenses: [],
      loading: false,
      /* eslint-disable */
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      fields: [
        {key: 'firstName', label: this.$t('User Name'), sortable: true, sortDirection: 'desc', class: 'text-left'},
        {key: 'deviceName', label: this.$t('Device'), sortable: true, class: 'text-center'},
        {key: 'groups', label: this.$t('Groups'), sortable: true, class: 'text-center'},
        {key: 'status', label: this.$t('Status'), sortable: true, class: 'text-center'},
        {key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center'},
        {key: 'actions', label: this.$t('Actions'), sortable: false, class: 'text-center'}
      ],
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}],
      resetPasswordData: {
        password: '',
        repeatPassword: ''
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      newUser: {
        email: null,
        firstName: null,
        lastName: null,
        password: null,
        companyId: null,
        status: 'Active',
        role: null
      }
    }
  },
  validations: {
    resetPasswordData: {
      password: {
        required,
        minLength: minLength(6)
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      }
    },
    newUser: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    // Set the initial number of items
    this.$store.dispatch('fetchUsers')
    this.totalRows = this.$store.state.users.length
    // this.mapUsers()
    console.log(this.$store.state.users.length)
  },
  methods: {
    isEmailValid: function(email) {
      return this.reg.test(email);
    },
    getAvailableLicenses () {
      var self = this
      console.log('fetch fetch fetch')
      var licenses = this.$firebase.firestore().collection('companies').doc(this.$store.state.user.data.companyId).collection('licenses')
      licenses.get().then(function (querySnapshot) {
        self.availableLicenses = [{text: self.$t('Select License'), value: null}]
        querySnapshot.forEach(function (doc) {
          let licenseData = doc.data()
          if (licenseData.userId == null){
            var licenseText = ''
            if(licenseData.hasOwnProperty('type') && licenseData.type != null){
              licenseText = licenseData.type
            } else {
              licenseText = "User"
            }
            licenseText += ' ' + moment(String(licenseData.expiryDate.toDate())).format('DD/MM/YYYY kk:mm').toString()

            self.availableLicenses.push({value: doc.id, text: licenseText})
          }
        })
      })
    },
    createUser (e) {
      e.preventDefault()

      this.$v.newUser.$touch()
      if (this.$v.newUser.$anyError) {
        return
      }

      if (!this.isEmailValid(this.newUser.email)) {
        this.newUser.email = this.newUser.email + '@yescheflabel.com'
      }

      this.loading = true
      let self = this
      console.log(self.newUser)
      self.newUser.companyId = this.$store.state.user.data.companyId
      const createCompanyUser = this.$firebase.functions().httpsCallable('createSingleUser')
      createCompanyUser(this.newUser).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$store.dispatch('fetchUsers')
          self.$swal({
            title: self.$t('User Created!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    resetPassword (e) {
      var self = this
      e.preventDefault()
      console.log(this.resetPasswordData)
      this.$v.resetPasswordData.$touch()
      if (this.$v.resetPasswordData.$anyError) {
        return
      }
      this.loading = true
      const resetPassword = this.$firebase.functions().httpsCallable('resetPassword')
      resetPassword(this.resetPasswordData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Password changed!'),
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetPasswordModal (uid) {
      this.$bvModal.show('modal-reset-password')
      this.resetPasswordData.user = uid
    },
    resetPasswordModalVars() {
      this.resetPasswordData.password = ''
      this.resetPasswordData.repeatPassword = ''
      this.$v.$reset()
    },
    resetUserModal () {
      this.newUser.email = ''
      this.newUser.firstName = null
      this.newUser.lastName = null
      this.newUser.password = ''
      this.newUser.license = null
      this.$v.$reset()
    },
    removeUser (item) {
      var self = this
      this.$swal({
        title: self.$t('Are you sure?'),
        text: self.$t('Deleting this user cannot be undone!'),
        showConfirmButton: true,
        showCancelButton: true
      }).then(function (value) {
        if (value.value) {
          self.loading = true
          const removeUser = self.$firebase.functions().httpsCallable('deleteUser')
          removeUser({id: item.id, companyId: self.$store.state.user.data.companyId}).then(function (result) {
            // success or error handling
            // console.log(result)
            // if (result.data) {
              self.$swal({
                title: self.$t('User Deleted!'),
                type: 'success',
                timer: 2000,
                showConfirmButton: false
              })
            self.$store.dispatch('removeUser', item.id)
            // }
            self.loading = false
          })
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LicensedUsers.vue